export default __webpack_public_path__ + "static/media/mastercard.a34e2abf.svg";